import { StatusPill } from "./StatusPill";

interface ReachableBadgeProps {
  reachable: boolean | null | undefined;
  online?: boolean;
}

export function ReachableBadge({
  reachable,
  online = true,
}: ReachableBadgeProps) {
  if (!online) {
    return <StatusPill variant="idle">Unknown</StatusPill>;
  }

  if (reachable === null || reachable === undefined) {
    return <StatusPill variant="idle">Not yet checked</StatusPill>;
  }

  return reachable ? (
    <StatusPill variant="active">Reachable</StatusPill>
  ) : (
    <StatusPill variant="offline">Unreachable</StatusPill>
  );
}
